import React from 'react';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';

import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';

import Modal from 'four-nets/ui-v2/modal/modal';

import defaultStyles from './product-price-history-stack-view.scss';

interface Record {
    createdTime: Date;
    price: number;
}

export interface Props {
    styles: typeof defaultStyles;
    priceHistory: Record[];
    onClose?: () => void;
    open: boolean;
}

class ProductPriceHistoryStackView extends React.Component<Props> {
    onClose = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    render() {
        const { styles, priceHistory, open } = this.props;

        return (
            <Modal
                title={
                    <FormattedMessage id='BAZAAR_PRICE_HISTORY'>
                        {message => <span className={styles.capitalizeFirst}>{message}</span>}
                    </FormattedMessage>
                }
                open={open}
                onClose={this.onClose}
            >
                <div className={styles.mainWrapper}>
                    {priceHistory.map(record => (
                        <span className={styles.record}>
                            <FormattedMessage id='PRICE' />
                            &nbsp;
                            <FormattedDateAgoView value={record.createdTime} />
                            &nbsp;
                            <FormattedMessage id='BAZAAR_WAS_PRICE' values={{ price: record.price }} />
                        </span>
                    ))}
                </div>
            </Modal>
        );
    }
}

export default Styled(defaultStyles)(ProductPriceHistoryStackView);
